import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import PageHeading from '../../../common/Heading/PageHeading';
import { Invoices } from './Invoices'
import { LeftGrid } from '../../../Episode/Episode.Styled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { ContentTitle } from '../../../ui/styled';
import Box from '@mui/material/Box';
import BackIcon from '../../../common/Back/BackIcon';

const PrintInvoices = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Box>
      <ContentTitle container>
      <Grid item xs={6}>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <BackIcon />
          <PageHeading title='Invoices' />
        </Box>
      </Grid>
      <LeftGrid item xs={6}>
        <Button
          variant='contained'
          style={{ justifyContent: 'flex-end' }}
          onClick={() => handlePrint()}
        >
          Print
        </Button>
      </LeftGrid>
      </ContentTitle>
      <Invoices ref={componentRef} />
    </Box>


  );
};

export default PrintInvoices